import { render, staticRenderFns } from "./SalaryTaxExcel.vue?vue&type=template&id=d5da64d6&scoped=true"
import script from "./SalaryTaxExcel.vue?vue&type=script&lang=js"
export * from "./SalaryTaxExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5da64d6",
  null
  
)

export default component.exports